var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.68 7.54H8.32a2.563 2.563 0 00-2.56 2.56v9.6a2.563 2.563 0 002.56 2.56H16v2.56a.642.642 0 00.64.64.642.642 0 00.5-.24l2.367-2.96h4.173a2.563 2.563 0 002.56-2.56v-9.6a2.563 2.563 0 00-2.56-2.56zm1.28 12.16a1.28 1.28 0 01-1.28 1.28H19.2a.642.642 0 00-.5.24l-1.42 1.776V21.62a.64.64 0 00-.64-.64H8.32a1.28 1.28 0 01-1.28-1.28v-9.6c0-.707.573-1.28 1.28-1.28h15.36c.707 0 1.28.573 1.28 1.28v9.6zm-3.84-3.2a.64.64 0 01-.64.64h-8.96a.64.64 0 110-1.28h8.96a.64.64 0 01.64.64zm-10.24-3.2a.64.64 0 01.64-.64h5.12a.64.64 0 110 1.28h-5.12a.64.64 0 01-.64-.64z",
    fill: "#fff"
  })));
}

export default SvgChatinline;